/** Helper for joining class names together. Accepts strings or objects. It filters out falsey values. */
export function classNames(...args: (string | Record<string, boolean> | undefined)[]) {
  const objects = args.filter((arg) => typeof arg === "object") as Record<string, boolean>[];
  const strings = args.filter((arg) => typeof arg === "string") as string[];
  const objectKeys = objects.map((obj) => Object.keys(obj).filter((key) => !!obj[key])).flat();
  const results = [...strings, ...objectKeys].filter(Boolean).join(" ").trim();
  return results;
}
